var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTodesfallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Todesfall-Icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F3F3F3",
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.000000, 15.000000)",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,13 L7,29 L17.098,29 L17.098,16.49 C17.098,16.49 14.557,15.623 12.826,14.691 C11.096,13.759 8.577,13.043 7,13 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0688809,9.81 C11.0688809,9.81 12.1282553,10.232 13.2007231,9.818 C13.2007231,9.818 16.6145273,8.601 14.6398059,4.186 C14.6398059,4.186 13.254287,1.268 12.1092104,-1.0658141e-14 C12.1092104,-1.0658141e-14 10.4427788,2.389 9.63455943,4.081 C9.63455943,4.081 7.49676571,8.182 11.0688809,9.81 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 33,
    x2: 24,
    y2: 33,
    id: "Stroke-5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodesfallIcon);
export default __webpack_public_path__ + "static/media/todesfall-icon.81e8875f.svg";
export { ForwardRef as ReactComponent };